var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowseGameBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154.003 213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M13.033,223.419A11.4,11.4,0,0,1,3.75,218.94a14.794,14.794,0,0,1-2.422-4.678A18.032,18.032,0,0,1,.5,208.8V24.976a12.348,12.348,0,0,1,2.153-7.447,15.006,15.006,0,0,1,5-4.4A23.871,23.871,0,0,1,15.038,10.5H140.027l.026,0a13.747,13.747,0,0,1,1.451-.078,12.034,12.034,0,0,1,5.321,1.206,12.543,12.543,0,0,1,4.1,3.223,14.869,14.869,0,0,1,2.644,4.658,16.376,16.376,0,0,1,.936,5.48V178.834a12.477,12.477,0,0,1-4.039,9.5c-2.483,2.313-6.039,3.995-10.569,5h-.009L14.91,223.3A14.91,14.91,0,0,1,13.033,223.419Z",
    transform: "translate(-0.497 -10.419)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseGameBackground);
export default __webpack_public_path__ + "static/media/browse-game-background.5bb4bcd9b83f6c5f054611b32fb65536.svg";
export { ForwardRef as ReactComponent };